import { Component, Output, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto } from 'sg-api';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';

@Component({
  selector: 'app-sgkb980d',
  templateUrl: './sgkb980d.component.html',
  styleUrl: './sgkb980d.component.scss'
})
export class Sgkb980dComponent implements OnInit, OnDestroy {

  contModInputForm: UntypedFormGroup;

  @Output() errorMessageModelArray: Array<SgAriaMessage>;
  // コードマスタ取得
  @Output() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   */
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private codeConversionMstService: CodeConversionMstService,
  ) {
    this.contModInputForm = this.fb.group({});
  }

  /**
   * 初期処理
   * @memberof Sgkb980dComponent
   */
  ngOnInit(): void {

    this.codeConversionMstService.getCodeConversionMst([
      "S001000",// 停止時要配慮フラグ
      "S001800",// 会社コード
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.codeConversionMstMap = data;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
